import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import Modal from "react-modal";
import CardImage from "./CardImage";
import { format } from "date-fns";
import CommentBox from "./CommentBox";
import SelectMenu from "../components/SelectMenu";

const customStyles = {
  content: {
    inset: "unset",
    padding: 0,
  },
};

const DataDisplay = (props) => {
  let { code, loadingBtn, data, locationList, UploadImg, UpdateData, SaveData } = props;
  const [showUpload, setShowUpload] = useState(false);
  const [showComment, setShowComment] = useState(false);

  if (data === undefined) {
    return (
      <Redirect
        to={{
          pathname: "/asset/not-found",
          search: `?code=${code}`,
        }}
      />
    );
  }

  Modal.setAppElement("#main");

  const actionToggle = () => {
    setShowComment(!showComment);
    let fab = document.querySelector("#fab");
    fab.classList.toggle("show");
  };

  return (
    <>
      {data ? (
        <>
          <div className="flex items-center justify-center p-4">
            <div>
              {data?.AstPhoto ? (
                <CardImage
                  base64Src={data.AstPhoto}
                  //setShowUpload={setShowUpload}
                />
              ) : (
                <CardImage base64Src={false} />
              )}
            </div>
            {/* <div className="hidden sm:block">
              <div className="font-bold text-lg">{data?.Name}</div>
              <div>
                {data.Id} {"-"} {data.No}
              </div>
              <div className="italic">{data.Barcode}</div>
            </div> */}
          </div>
          {/* <div className="sm:hidden block text-center mb-4">
            <div className="font-bold text-lg">{data?.Name}</div>
            <div>
              {data.Id} {"-"} {data.No}
            </div>
            <div className="italic">{data.Barcode}</div>
          </div> */}
          <hr />
          <div className="grid grid-cols-3 gap-3 p-4">
            <div className="text-key">AssetId :</div>
            <div className="text-value">
              {data.Id} {"-"} {data.No}
            </div>
            <div className="text-key">AssetName :</div>
            <div className="text-value">{data?.Name}</div>
            <div className="text-key">Category :</div>
            <div className="text-value">
              {data.CategoryCode} : {data.AstCateDesc}
            </div>
            <div className="text-key">Input date :</div>
            <div className="text-value">{data?.InputDate ? format(new Date(data?.InputDate), "dd/MM/yyyy") : ""}</div>
            <div className="text-key">Acquired date :</div>
            <div className="text-value">
              {data?.AcquireDate ? format(new Date(data?.AcquireDate), "dd/MM/yyyy") : ""}
            </div>
            <div className="text-key">Remain Qty. :</div>
            <div className="text-value">
              {data.Qty} {data.UnitCode}
            </div>
            <div className="text-key">Location :</div>
            <div className="text-value">
              {/* {data.LocationCode} : {data.AstLocDesc} */}
              <SelectMenu
                title={""}
                list={locationList}
                selectDefault={data.objLoc}
                setSelectDefault={(e) => UpdateData(e, "LocCode")}
                keyName={"LocCode"}
                keyDesc={"Description"}
              />
            </div>
            <div className="text-key">Transfer date :</div>
            <div className="text-value">
              {data?.TransferDate ? format(new Date(data?.TransferDate), "dd/MM/yyyy") : ""}
            </div>
            <div className="text-key">Serial No. :</div>
            <div className="text-value">
              <input
                type="text"
                className="textBox-value"
                name="SerialNo"
                value={data.SerialNo}
                onChange={(e) => UpdateData(e)}
              />
            </div>
            <div className="text-key">Specification :</div>
            <div className="text-value">
              <input
                type="text"
                className="textBox-value"
                name="Spec"
                value={data.Spec}
                onChange={(e) => UpdateData(e)}
              />
            </div>
            <div className="text-key">Remark :</div>
            <div className="text-value">
              <textarea
                type="text"
                className="textBox-value"
                rows={4}
                name="Remark"
                value={data.Remark}
                onChange={(e) => UpdateData(e)}
              />
            </div>
          </div>

          <div className="flex justify-center">
            <button
              className="mt-4 mb-12 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              disabled={loadingBtn}
              onClick={() => {
                SaveData();
              }}
            >
              {loadingBtn && (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              )}
              Save
            </button>
            <button
              className="ml-5 mt-4 mb-12 inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm  font-medium text-gray-700 hover:bg-gray-50"
              onClick={() => {
                props.history.push("/");
              }}
            >
              Cancel
            </button>
          </div>

          {showUpload && (
            <Modal
              isOpen={showUpload}
              //{afterOpenModal}
              onRequestClose={() => setShowUpload(false)}
              style={customStyles}
              shouldCloseOnOverlayClick={true}
            >
              <section id="bottom-navigation" className="block fixed inset-x-0 bottom-0 z-10 bg-white shadow">
                <div id="tabs" className="flex justify-between m-4">
                  <div>
                    <label htmlFor="AstPhoto">
                      {/* <button onClick={(e) => console.log(e, "upload")}>📷 Upload New Picture</button> */}
                      <span>📷 Upload New Picture</span>
                    </label>
                    <input
                      id="AstPhoto"
                      name="AstPhoto"
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        UploadImg(e);
                        setShowUpload(false);
                      }}
                    />
                  </div>
                </div>
              </section>
            </Modal>
          )}
          {showComment && <CommentBox data={data} />}

          <button
            type="button"
            id="fab"
            className="fixed z-50 bottom-4 right-4 w-12 h-12 rounded-full bg-gray-900 text-white block lg:hidden"
            onClick={() => actionToggle()}
          >
            <span className="open">💬</span>
            <span className="close">❌</span>
          </button>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default withRouter(DataDisplay);
